import React from 'react';
import ReactDOM from 'react-dom/client';
import { loadRuntimeConfig, resolveApiBase } from './config/runtime';
import { preloadHeroVideo } from './utils/preloadHeroVideo';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

loadRuntimeConfig()
  .then(() => resolveApiBase())
  .then(() => preloadHeroVideo())
  .then(() => {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  });

reportWebVitals();
